import React, { useContext } from 'react'
import classnames from 'classnames'
import { InputError } from 'lp-components'
import { PaymentFormContext } from './GpiWrapper'

// Allow any component to render the GPI payment form fields
// these fields are styled via:
// (1) `gpi-wrapper` class in _forms.scss
// (2) the `style` object passed to the form configuration in GpiWrapper
export default function GpiForm() {
  // PaymentFormContext comes with a several keys:
  // (1) `formErrors`: an object with error messages for any invalid payment fields
  // (2) `hasBeenSubmitted`: a boolean indicating whether the form has been submitted by the user
  // (3) `arePaymentFieldsLoading`: a boolean indicating whether the payment form JavaScript is loading
  // (4) `isDisabled`: a boolean indicating whether the GPI payments experience is currently disabled to the user
  const { formErrors, hasBeenSubmitted, arePaymentFieldsLoading } = useContext(
    PaymentFormContext
  )
  return (
    <div
      className={classnames('gpi-wrapper', {
        'gpi-wrapper--disabled': arePaymentFieldsLoading,
      })}
    >
      <fieldset>
        <label htmlFor="card-number">Card Number</label>
        {/* GPI JavaScript library uses this anchor to render the Card Number field */}
        <div id="card-number" />
        <InputError
          error={(hasBeenSubmitted && formErrors['card-number']) || ''}
          invalid={hasBeenSubmitted && !!formErrors['card-number']}
          touched
        />
      </fieldset>
      <fieldset className="short-input input-left">
        <label htmlFor="card-expiration">Expiration Date</label>
        {/* GPI JavaScript library uses this anchor to render the Card Expiration field */}
        <div id="card-expiration" />
        <InputError
          error={(hasBeenSubmitted && formErrors['card-expiration']) || ''}
          invalid={hasBeenSubmitted && !!formErrors['card-expiration']}
          touched
        />
      </fieldset>
      <fieldset className="short-input">
        <label htmlFor="card-cvv">CVV</label>
        {/* GPI JavaScript library uses this anchor to render the Card CVV field */}
        <div id="card-cvv" />
        <InputError
          error={(hasBeenSubmitted && formErrors['card-cvv']) || ''}
          invalid={hasBeenSubmitted && !!formErrors['card-cvv']}
          touched
        />
        <p className="security-code-copy">
          3 to 4 digit number typically located on the back of your card.
        </p>
      </fieldset>
    </div>
  )
}